import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'text-[13px] font-medium leading-none select-none',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-60',
        'group-data-[disabled=true]:opacity-60',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
